import { FIRST_CONTENT_LEVEL_CLASS_NAME, SECOND_CONTENT_LEVEL_CLASS_NAME } from './Navigation.const';
export var isMobile = function () { return (typeof window !== 'undefined' ? window.innerWidth <= 720 : false); };
export var updateIndexes = function (className, index) {
    var _a, _b, _c, _d;
    var state = {};
    if (className === FIRST_CONTENT_LEVEL_CLASS_NAME) {
        state = (_a = {}, _a[FIRST_CONTENT_LEVEL_CLASS_NAME] = index, _a);
    }
    else if (className === FIRST_CONTENT_LEVEL_CLASS_NAME + " active") {
        state = (_b = {}, _b[FIRST_CONTENT_LEVEL_CLASS_NAME] = null, _b);
    }
    else if (className === SECOND_CONTENT_LEVEL_CLASS_NAME) {
        state = (_c = {}, _c[SECOND_CONTENT_LEVEL_CLASS_NAME] = index, _c);
    }
    else if (className === SECOND_CONTENT_LEVEL_CLASS_NAME + " active") {
        state = (_d = {}, _d[SECOND_CONTENT_LEVEL_CLASS_NAME] = null, _d);
    }
    return state;
};
//# sourceMappingURL=Navigation.functions.js.map